import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./App.css";
import AppBarh from "./components/AppBarh";
import MainCarousel from "./components/MainCarousel";
import EventBar from "./components/EventBar";
import About from "./components/About";
import ResponsibilityBar from "./components/ResponsibilityBar";
import NewsBar from "./components/NewsBar";
import PresidentMessage from "./components/PresidentMessage";
import Footer from "./components/Footer";

function App() {
    const location = useLocation(); // Get current route path

    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.substring(1));
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]); // Runs when URL changes

    return (
      <div>
        <AppBarh />
        <MainCarousel />
        <EventBar />
        <About />
        <ResponsibilityBar />
        <NewsBar />
        <PresidentMessage />
        <Footer />
      </div>
    );
}

export default App;
